export { CloudSitePage } from './src/cloud-site-page';
